import { useNavigate, useParams } from 'react-router-dom';
import { HiOutlinePencilAlt } from "react-icons/hi";
import { FaRegTrashAlt } from "react-icons/fa";
import Check from "~/components/svg/Check";
import Close from "~/components/svg/Close";
import { useState, useEffect } from 'react';
import { conversationList, useConversation } from "~/helpers/store";
import axios from "axios";
import { cn } from '~/utils/';
import { exportToTxt } from '~/helpers/export';
import Swal from 'sweetalert2'

export default function Conversation({ conversation }) {
    const navigate = useNavigate();
    const { conversationId } = useParams();
    const cState = conversationList((state) => state);
    const convoState = useConversation((state) => state);
    const [ title, setTitle ] = useState(conversation?.title);
    const [ isRename, setIsRename ] = useState(false);

    const renameConversation = () => {
        cState.setConversation(cState.conversation.map((convo)=>{
            if(convo.conversationId === conversationId) convo.title = title;
            return convo;
        }));
        axios.post(`/api/convos/rename`, {
            conversationId,
            title
        });
        setIsRename(false);
    };

    const confirmDeleteConversation = () => {
        const id = conversationId;
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                cState.setConversation(cState.conversation.filter((convo)=>{
                    if(convo.conversationId !== id) return convo;
                    return;
                })); 
                axios.post(`/api/convos/remove`, {
                    conversationId
                });
                navigate(`/chat/new`);
            }
        });
    }

    const getChatConversation = () => {
        let data = "";
        convoState.message.map((convo) => {
            let preFix = convo.sender.toLowerCase() === 'user' ? "User: " : "System: ";
            if(data) {
                data += "\n" + preFix + convo.text;
            } else {
                data += preFix + convo.text;
            }
        });
        let convoPrefix = "Conversation History \n########################\n";
        return convoPrefix + data;
    }

    useEffect(()=>{
        setIsRename(false);
    }, [conversationId]);

    if(!conversation?.conversationId) return;

    return (
        <div data-testid="convo-item" 
        className={cn("conversation-link group relative flex cursor-pointer items-center gap-3 break-all rounded-md py-2 px-3 pr-1 hover:bg-gray-800", 
            { active: conversationId === conversation?.conversationId }
        )} 
        role="button" tabIndex={0} aria-label="conversation link"
        onClick={(e)=>{
            const target = e.target as Element; // Cast to Element
            if (!target.closest(".convo-actions")) {
                navigate(`/chat/${conversation?.conversationId}`);
            }
        }}>
            <div className="relative max-h-5 flex-1 overflow-hidden text-ellipsis break-all w-36 whitespace-nowrap" aria-label="conversation title">
                { isRename ? 
                <input type="text" value={title} 
                onChange={event => setTitle(event.target.value)}
                onKeyDown={(e) => {
                    if(e.keyCode === 13) renameConversation(); // Enter
                }}
                onBlur={()=>{
                    setTimeout(()=>{
                        setIsRename(false);
                    }, 500);
                }}
                className="w-[100%] h-[100%]"
                style={{
                    "outline": "0",
                    "border": "1px solid black",
                    "background": "transparent"
                }}></input>
                : 
                conversation?.title }
            </div>
            { conversationId === conversation?.conversationId ?
                isRename ? 
                <div>
                    <div className="inline-block mx-1 convo-actions" aria-label="Rename" title="Rename"
                    onClick={renameConversation}><Check fill="#fff"/></div>
                    <div className="inline-block mx-1 convo-actions" aria-label="Cancel" title="Cancel"
                    onClick={()=>{setIsRename(false);}}><Close opacity="1" fill="#fff"/></div>
                </div>
                :
                <div>
                    <div className="inline-block mx-1 convo-actions" aria-label="Rename Chat" title="Rename Chat"
                    onClick={()=>{
                        setIsRename(true);
                        setTimeout(()=>{
                            const elem = document.querySelector(".conversation-link input") as HTMLElement;
                            elem.focus();
                        }, 500);
                    }}><img src="/assets/edit-conversation-name.svg"/></div>
                    <div className="inline-block mx-1 convo-actions" aria-label="Delete Chat" title="Delete Chat"
                    onClick={()=>{
                        confirmDeleteConversation();
                    }}><img src="/assets/delete-conversation.svg"/></div>
                    <div className="inline-block mx-1 convo-actions" aria-label="Export Chat" title="Export Chat"
                    onClick={()=>{
                        const data = getChatConversation();
                        exportToTxt(data);
                    }}><img src="/assets/export-conversation.svg"/></div>
                </div>
                : <></>
            }
        </div>
    );
}